"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBulletConfiguration = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var commonConfiguration_1 = require("../_chartCreators/commonConfiguration");
var responsive_1 = require("../_chartCreators/responsive");
var BULLET_TEMPLATE = {
    chart: {
        type: "bar",
    },
    plotOptions: {
        bar: {
            maxPointWidth: commonConfiguration_1.MAX_POINT_WIDTH,
            dataLabels: {
                enabled: false,
            },
        },
        bullet: {
            maxPointWidth: commonConfiguration_1.MAX_POINT_WIDTH,
            tooltip: {
                followPointer: true,
            },
            targetOptions: {
                borderWidth: 0,
            },
        },
        series: {
            states: {
                hover: {
                    enabled: false,
                },
            },
            grouping: false,
            borderWidth: 0,
        },
    },
    yAxis: [
        {
            stackLabels: {
                enabled: false,
            },
        },
    ],
};
function getBulletConfiguration(config) {
    var bulletConfiguration = cloneDeep_1.default(BULLET_TEMPLATE);
    if ((config === null || config === void 0 ? void 0 : config.enableCompactSize) && !(config === null || config === void 0 ? void 0 : config.zoomInsight)) {
        var reversed = true;
        return tslib_1.__assign(tslib_1.__assign({}, bulletConfiguration), { responsive: responsive_1.getCommonResponsiveConfig(reversed) });
    }
    return bulletConfiguration;
}
exports.getBulletConfiguration = getBulletConfiguration;
//# sourceMappingURL=bulletConfiguration.js.map